/** Cuánto tiempo se considera «el mismo fallo» y no vale la pena repetir el aviso. */
export const VENTANA_REPETIDOS_MS = 10_000

/**
 * Decide si un aviso vale la pena mostrarlo, o si es el mismo de hace un momento.
 *
 * El visor dispara su callback `error` **varias veces por un solo fallo**: al quedarse sin red
 * fallan la plantilla, los formatos de exportación y el documento, y cada uno levanta su error.
 * Sin filtro salían dos o tres avisos idénticos apilados, que es ruido, no información.
 *
 * Se compara el mensaje y el momento en vez de usar un temporizador, para poder probarlo pasándole
 * el reloj y no depender de esperas reales.
 */
export const creaFiltroDeAvisosRepetidos = (
  ventanaMs: number = VENTANA_REPETIDOS_MS,
): ((mensaje: string, ahoraMs: number) => boolean) => {
  let ultimoMensaje: string | null = null
  let ultimoMomento = 0

  return (mensaje: string, ahoraMs: number): boolean => {
    const esElMismo = mensaje === ultimoMensaje && ahoraMs - ultimoMomento < ventanaMs

    // El momento se refresca siempre: mientras el fallo siga repitiéndose, se sigue callando.
    ultimoMensaje = mensaje
    ultimoMomento = ahoraMs

    return !esElMismo
  }
}
